;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"
import Menu from "../Menu"
import MenuItem from "../MenuItem"
import Divider from "../Divider"
import {
  TOP_NAV_MENU_TYPE_ACCOUNT,
  TOP_NAV_MENU_TYPE_ALL_GROUPS_ADMIN,
  TOP_NAV_MENU_TYPE_ALL_USERS_ADMIN,
  TOP_NAV_MENU_TYPE_ADMIN_NEWSLETTER,
  TOP_NAV_MENU_TYPE_ADMIN_AI_USAGE,
  TOP_NAV_MENU_TYPE_ADMIN_ARTICLES,
  TOP_NAV_MENU_TYPE_ALL_ORGANIZATIONS_ADMIN,
  TOP_NAV_MENU_TYPE_LOGOUT,
} from "../constants"

export default function MenuAdmin({
  trigger,
  handleLogout,
}: {
  trigger: React.ReactElement
  handleLogout: () => void | Promise<void>
}) {
  return (
    <Menu trigger={trigger}>
      <MenuItem topNavMenuItemType={TOP_NAV_MENU_TYPE_ALL_GROUPS_ADMIN} />
      <MenuItem topNavMenuItemType={TOP_NAV_MENU_TYPE_ALL_USERS_ADMIN} />
      <MenuItem topNavMenuItemType={TOP_NAV_MENU_TYPE_ADMIN_NEWSLETTER} />
      <MenuItem topNavMenuItemType={TOP_NAV_MENU_TYPE_ADMIN_ARTICLES} />
      <MenuItem topNavMenuItemType={TOP_NAV_MENU_TYPE_ALL_ORGANIZATIONS_ADMIN} />
      <MenuItem topNavMenuItemType={TOP_NAV_MENU_TYPE_ADMIN_AI_USAGE} />
      <Divider />
      <MenuItem topNavMenuItemType={TOP_NAV_MENU_TYPE_ACCOUNT} />
      <MenuItem
        topNavMenuItemType={TOP_NAV_MENU_TYPE_LOGOUT}
        handleLogout={handleLogout}
      />
    </Menu>
  )
}
